export class DiscountPriceRequest {
    productId: number;
    productName?: string;
    specialPrice?: number;
    discountValue?: number;
    setId?: number;
    customerSelectedSiteId: number;
    customerSelectedAccountId: number;
}